import React, { createContext, useEffect, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [publicAccess, setPublicAccess] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getPublicAccessInfo();
  }, []);

  async function getPublicAccessInfo() {
    try {
      const response = await fetch("https://uploads.jellyo.net/api/auth/publicAvailable", {
        credentials: "include",
      });
      const responseData = await response.json();
      setPublicAccess(responseData.status);
    } catch (error) {
      console.error('Error checking public access:', error);
      setPublicAccess(false);
    } finally {
      setIsLoading(false);
    }
  }

  async function authenticatePassword(password) {
    try {
      const response = await fetch("https://uploads.jellyo.net/api/auth/publicAccess", {
        method: "post",
        credentials: "include",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({ password })
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setPublicAccess(true);
        return { success: true, message: "Authentication successful" };
      } else {
        return { success: false, message: responseData.message || "Authentication failed" };
      }
    } catch (error) {
      console.error('Error during authentication:', error);
      return { success: false, message: "An error occurred. Please try again." };
    }
  }

  return (
    <AppContext.Provider value={{ 
      publicAccess, 
      setPublicAccess,
      isLoading,
      getPublicAccessInfo,
      authenticatePassword
    }}>
      {children}
    </AppContext.Provider>
  );
};